import { classNames } from "primereact/utils";

import { useListToolbarContext } from "../list-toolbar.context";
import styles from "../list-toolbar.module.scss";
import type { ListToolbarMenuProps } from "../types-list-toolbar";

export function ListToolbarMenu({ children, className, ...rest }: ListToolbarMenuProps) {
  const { classNames: parts, partTestId } = useListToolbarContext();

  return (
    <div
      className={classNames(styles.menu, parts.menu, className)}
      data-testid={partTestId("menu")}
      {...rest}
    >
      {children}
    </div>
  );
}
ListToolbarMenu.displayName = "ListToolbar.Menu";
